import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/date-icon.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_date_picker = _resolveComponent("a-date-picker")!

  return (_openBlock(), _createBlock(_component_a_date_picker, _mergeProps({
    format: "YYYY",
    mode: "year",
    value: _ctx.yearValue,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.yearValue) = $event)),
    open: _ctx.isOpen,
    onOpenChange: _ctx.handleOpenChange,
    onPanelChange: _ctx.handlePanelChange
  }, _ctx.$attrs), {
    suffixIcon: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 16, ["value", "open", "onOpenChange", "onPanelChange"]))
}